import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import FaqMain from "./FaqMain";
import Footer from "../../components/Footer";

const Faq = () => {
  return (
    <>
      <HeaderFour />

      <FaqMain />

      <Footer />
    </>
  );
};

export default Faq;
